module.exports = __webpack_public_path__ + "e60202e4f718f3c8f770bbe6dd024bd0.svg";